const angular = require('angular');

const { stickyDirectiveDefinition } = require('./sticky.directive');

angular.module('oly.common')
    .directive('olySticky', [stickyDirectiveDefinition]);



// WEBPACK FOOTER //
// ./src/olycommon/sticky/index.js